import auth1 from "../assets/pictures/home/auth1.jpg";
import logo from "../assets/logos/RG copy 2.png";
import v1 from "../assets/videos/home55.webm";
import { useRef, useState } from "react";
import bride1 from "../assets/pictures/home/bride1.jpeg";
import bride2 from "../assets/pictures/home/bride2.jpeg";
import bride3 from "../assets/pictures/home/bride3.jpeg";
import bride4 from "../assets/pictures/home/bride4.jpeg";
import authv1 from "../assets/videos/home55.webm";
import { cls } from "../components/Utility";
import DesktopWa from "../components/DesktopWa";
import Call from "../components/Call";

export default function ArtAndCreativity() {
  const scrollContainerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    e.preventDefault(); // Prevent text selection
    setIsDragging(true);
    setStartX(e.pageX - scrollContainerRef.current.offsetLeft);
    setScrollLeft(scrollContainerRef.current.scrollLeft);
  };

  const handleMouseUpOrLeave = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollContainerRef.current.offsetLeft;
    const walk = (x - startX) * 1; // Adjust the multiplier for speed (lower = slower)
    scrollContainerRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <>
      <div className={cls("hidden", "xl:flex")}>
        <div className="relative w-full h-screen overflow-hidden">
          <div className="w-full h-full">
            <img src={auth1} />
          </div>
          <div className="absolute inset-x-0 bottom-[60px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[25px] font-semibold tracking-widest fadeInUp ">
                CONCEPT X CREATIVITY x ART
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div className={cls("flex overflow-x-hidden", "xl:hidden")}>
        <div className="relative w-full overflow-hidden">
          <img src={auth1} className="w-full h-[500px] object-cover" />

          <div className="absolute inset-x-0 top-[420px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[20px] font-semibold tracking-widest fadeInUp ">
                CONCEPT X CREATIVITY x ART
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-[40px] mb-[30px] ">
        <p
          className={cls(
            "text-[14px] font-[description1] text-center pl-[20px] pr-[20px]",
            " xl:pl-[380px] xl:pr-[380px]"
          )}
        >
          {" "}
          Every frame we create begins with a concept, shaped by creativity, and
          finished as a piece of art. It's where imagination meets emotion, and
          stories come to life.
        </p>
        <div className="flex justify-center">
          <img src={logo} className="w-[70px] h-[70px] object-contain" />
        </div>
      </div>

      <div
        className={cls(
          "flex flex-col justify-center gap-[10px] pl-[20px] pr-[20px]",
          "xl:flex xl:flex-row xl:justify-center xl:gap-2 xl:pl-0 xl:pr-0"
        )}
      >
        <div className="flex justify-center xl:mb-[80px] mb-0">
          <video
            className="xl:w-[600px] xl:h-[1000px] w-full h-[500px] object-cover"
            autoPlay
            loop
            muted
          >
            <source src={v1} type="video/mp4" />
          </video>
        </div>
        <div className="flex justify-center">
          <img
            src={bride2}
            className="xl:w-[600px] xl:h-[1000px] w-full h-[500px] object-cover"
          />
        </div>
      </div>
      <div className={cls("hidden", "xl:flex")}>
        <div
          ref={scrollContainerRef}
          className={`fullscreen-scroll-container ${
            isDragging ? "dragging" : ""
          }`}
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseUpOrLeave}
          onMouseUp={handleMouseUpOrLeave}
          onMouseMove={handleMouseMove}
        >
          <div className="scroll-item">
            <img src={bride1} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride2} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride3} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride4} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride1} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride2} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride3} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride4} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride1} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride2} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride3} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride4} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride1} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride2} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride3} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride4} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride1} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride2} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride3} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride4} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride1} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride2} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride3} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride4} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride1} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride2} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride3} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride4} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride1} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride2} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride3} alt="Image 1" />
          </div>
          <div className="scroll-item">
            <img src={bride4} alt="Image 1" />
          </div>
        </div>
      </div>
      <div className={cls("flex mb-[10px] mt-[30px]", "xl:hidden")}>
        <div class="w-full overflow-x-auto no-scrollbar">
          <div class="flex ">
            <img
              src={bride1}
              class="w-[300px] h-[400px] object-cover p-[5px] "
            />
            <img
              src={bride1}
              class="w-[300px] h-[400px] object-cover p-[5px]"
            />
            <img
              src={bride1}
              class="w-[300px] h-[400px] object-cover p-[5px] "
            />
            <img
              src={bride1}
              class="w-[300px] h-[400px] object-cover p-[5px]"
            />
            <img
              src={bride1}
              class="w-[300px] h-[400px] object-cover p-[5px] "
            />
            <img
              src={bride1}
              class="w-[300px] h-[400px] object-cover p-[5px]"
            />
            <img
              src={bride1}
              class="w-[300px] h-[400px] object-cover p-[5px] "
            />
            <img
              src={bride1}
              class="w-[300px] h-[400px] object-cover p-[5px]"
            />
            <img
              src={bride1}
              class="w-[300px] h-[400px] object-cover p-[5px] "
            />
            <img
              src={bride1}
              class="w-[300px] h-[400px] object-cover p-[5px]"
            />
            <img
              src={bride1}
              class="w-[300px] h-[400px] object-cover p-[5px] "
            />
            <img
              src={bride1}
              class="w-[300px] h-[400px] object-cover p-[5px]"
            />
          </div>
        </div>
      </div>
      <img
        src={auth1}
        className="w-full xl:h-[600px] h-full object-cover mt-[30px] mb-[40px]"
      />
      <p className="text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px] pl-[20px] pr-[20px] text-center">
        {" "}
        We celebrate the union of culture, rich heritage, and timeless
        traditions through our lens. Every frame we capture reflects a deep
        respect for our roots, blending the grandeur of legacy with a modern
        artistic touch. With each story, we honor the essence of heritage,
        creating memories that resonate for generations.
        <br />
        <br /> We celebrate the union of culture, rich heritage, and timeless
        traditions through our lens. Every frame we capture reflects a deep
        respect for our roots, blending the grandeur of legacy with a modern
        artistic touch. With each story, we honor the essence of heritage,
        creating memories that resonate for generations.
        <br />
        <br /> We celebrate the union of culture, rich heritage, and timeless
        traditions through our lens. Every frame we capture reflects a deep
        respect for our roots, blending the grandeur of legacy with a modern
        artistic touch. With each story, we honor the essence of heritage,
        creating memories that resonate for generations.
        <br />
        <br /> We celebrate the union of culture, rich heritage, and timeless
        traditions through our lens. Every frame we capture reflects a deep
        respect for our roots, blending the grandeur of legacy with a modern
        artistic touch. With each story, we honor the essence of heritage,
        creating memories that resonate for generations.
      </p>

      <img
        src={auth1}
        className="w-full xl:h-[600px] h-full object-cover mt-[40px] mb-[40px]"
      />
      <div className="relative flex justify-center mb-[60px] pl-[20px] pr-[20px] xl:pl-0 xl:pr-0">
        <video
          className="xl:w-[700px] xl:h-[800px] w-full h-[500px] object-cover"
          autoPlay
          loop
          muted
        >
          <source src={authv1} type="video/mp4" />
        </video>
      </div>
      <div className="mt-[40px] mb-[40px] ">
        <p className="text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px] text-center pl-[20px] pr-[20px]">
          {" "}
          We celebrate the union of culture, rich heritage, and timeless
          traditions through our lens. Every frame we capture reflects a deep
          respect for our roots, blending the grandeur of legacy with a modern
          artistic touch. With each story, we honor the essence of heritage,
          creating memories that resonate for generations.
        </p>
        <div className="flex justify-center">
          <img src={logo} className="w-[70px] h-[70px] object-contain" />
        </div>
      </div>
      <div className="chat-icon">
        <DesktopWa />
      </div>
      <div className="chat-icon1">
        <Call phoneNumber="9980685056" />
      </div>
    </>
  );
}
